{
  "GENERAL": {
    "CLOSE": "Tanca",
    "SHOWING_RESULTS": "Es mostren {firstIndex}-{lastIndex} de {totalCount} elements",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Cercar",
      "EMPTY_STATE": "No s'ha trobat agents"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Es requereixen almenys {count}"
  }
}
